import { Link } from 'react-router-dom';

import { Card, Grid, Image, Text } from '@sayyesschool/frontend/ui-components';

export default function MaterialsGrid({ materials }) {
    return (
        <Grid
            className="material-grid-list"
            columns="6"
            content={materials.map(material =>
                <Card
                    key={material.id}
                    as={Link}
                    to={material.uri}
                >
                    <Card.Preview>
                        <Image
                            src={material.imageUrl}
                            alt=""
                        />
                    </Card.Preview>

                    <Card.Header>
                        <Text>{material.title}</Text>
                    </Card.Header>
                </Card>
            )}
        />
    );
}